// extracted by mini-css-extract-plugin
export var infoRow = "_n9-2";
export var labelContainer = "_n9-0";
export var rightInfo = "_n9-1";